export default {
  request_empty: 'The HTTP request was empty. If you have a flaky connection, please try again in a moment',
  credentials_not_found: 'Please check your email or password',
  admin_login_not_permitted: 'This app is only for regular users - admins please log in from the main site',
  request_empty: 'Request was empty - this is probably a bug. Please notify someone.',
  validation_error: 'Please correct form input',
  update_error: 'Could not save update',
  wrong_password: 'Wrong password',
  unauthorized_request: 'You are not authorized to do this',
  password_email_error: 'Could not send the password email',
  password_reset_error: 'Could not reset your password',
  password_must_match_confirmation: 'Password and confirmation do not match',
  oldpassword_too_short: 'Old password is too short - please check it',
  email_does_not_exist_in_database: 'Please check your email',
  email_already_exists: 'This email is already registered',
  invalid_email_address: 'Please check your email - invalid address',
  'validation.email_exists': 'This email is not registered here',
  stripe_connection_error: 'We are having trouble connecting with our payment processor - please try again'

};



// WEBPACK FOOTER //
// ./src/modules/apierrors.js